import React from 'react';


function PlainTextCell(props) {
    return (
        <div title={props.cellContent} key={new Date()} className='row__cell'>
            {props.cellContent}
        </div>
    );
}

export default PlainTextCell;
